/**
 * laylo-parallax.js
 * Scroll-driven parallax for the Laylo theme.
 * Compositor-only (translateY) — no layout reflow, no paint.
 *
 * ─── Two modes ───────────────────────────────────────────────────────────────
 *
 *  1. .parallax-img  (scroll-position based)
 *     Translates by scrollY × 0.05. Simple and effective for a single
 *     hero image anchored near the top of the page.
 *
 *       <div class="hero-wrap">   ← overflow: hidden; position: relative
 *         <img class="parallax-img" …>
 *       </div>
 *
 *  2. [data-laylo-parallax]  (viewport-centre based)
 *     Translates relative to how far the element's centre is from the
 *     viewport centre. Works correctly for images anywhere on the page.
 *     Optional speed override via data-laylo-speed (default 0.15).
 *
 *       <div class="section-wrap">   ← overflow: hidden; position: relative
 *         <img data-laylo-parallax data-laylo-speed="0.12" …>
 *       </div>
 *
 *     Speed guide:
 *       0.05  very subtle    0.15  editorial (default)
 *       0.25  dramatic       0.35  hero-scale maximum
 *
 * ─── Notes ───────────────────────────────────────────────────────────────────
 *  • Both modes use rAF + ticking — one frame scheduled per scroll event.
 *  • Exits early when prefers-reduced-motion is set.
 *  • Parent must have overflow: hidden. Size the element at height: 110%
 *    so parallax movement never reveals a gap at the edges.
 *  • will-change: transform is set in laylo-global.css (not inline).
 */

(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* ── Element references ──────────────────────────────────────────────────── */

  var simpleImg = document.querySelector('.parallax-img');

  var attrElements = Array.from(document.querySelectorAll('[data-laylo-parallax]'));
  var items = attrElements.map(function (el) {
    return {
      el: el,
      parent: el.parentElement,
      speed: parseFloat(el.dataset.layloSpeed) || 0.15
    };
  });

  if (!simpleImg && !items.length) return;

  /* ── Core update ─────────────────────────────────────────────────────────── */

  var ticking = false;
  var viewH = window.innerHeight;

  function update() {
    /* .parallax-img — scroll-position based */
    if (simpleImg) {
      var simpleOffset = (window.scrollY * 0.05).toFixed(2);
      simpleImg.style.transform = 'translateY(' + simpleOffset + 'px)';
    }

    /* [data-laylo-parallax] — viewport-centre based */
    if (items.length) {
      var halfView = viewH / 2;

      items.forEach(function (item) {
        var rect = (item.parent || item.el).getBoundingClientRect();

        if (rect.bottom < -200 || rect.top > viewH + 200) return;

        var centerY = rect.top + rect.height / 2;
        var offset = ((centerY - halfView) * item.speed).toFixed(2);

        item.el.style.transform = 'translateY(' + offset + 'px)';
      });
    }

    ticking = false;
  }

  /* ── Event listeners ─────────────────────────────────────────────────────── */

  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }, { passive: true });

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      viewH = window.innerHeight;
      update();
    }, 150);
  }, { passive: true });

  update();

})();
